module.exports = "/static/assets/971a0912df6f4d8a673e067a2a77eb87.png";